import * as React from 'react';
import { cloneDeep, debounce } from 'lodash';
import { DeleteOutlined } from '@ant-design/icons';
import { message } from 'antd';
import {
  ServiceSlot,
  FrameItem,
  ParameterType,
  ServiceInfo,
  serviceInfoToLocal,
  ReferenceNode,
  Connection,
  connectionToLocal
} from '@interface/index';
import {
  NiSpin,
  BodyGroup,
  NiTable,
  NiModal,
  NiInput,
  NiForm,
  NiSelect,
  sourceRender,
  AddButton,
  HelperPopover
} from '@component/index';
import {
  API,
  COPILOT_ACTION_KEYS,
  NiCommonCascader,
  SELECTION_KEY,
  SelectionOption,
  getSelectionOptions
} from '@config/index';
import { localizedString } from '@locale/index';
import {
  getFormattedName,
  getFullName,
  instance,
  isEqual
} from '@lib/index';

import '@style/component/value-check/index.less';
import { isLabeledStatement } from 'typescript';
import { TypeSelect } from '@component/data-query/modal-comps';

interface ServiceSlotTableProps {
  disabled?: boolean;
  frame: FrameItem;
  data: ServiceSlot[];
  onChange?: (data: ServiceSlot[]) => void;
}

interface ServiceSlotTableState {
  isNew: boolean;
  loading: boolean;
  index: number;
  data: ServiceSlot[];
  modalData?: ServiceSlot;
  options: ServiceInfo[];
  integrationOptions: Connection[]
}


export class ServiceSlotTable extends React.Component<ServiceSlotTableProps, ServiceSlotTableState> {
  constructor(props: ServiceSlotTableProps) {
    super(props);

    this.state = {
      loading: false,
      isNew: false,
      index: -1,
      data: [],
      options: [],
      integrationOptions: []
    };
  }

  actionListener: any;

  componentDidMount() {
    this.onInit();
    // this.actionListener = instance.on(COPILOT_ACTION_KEYS.ADD_SERVICE, (args: any) => {
    //   if (!args.serviceLabel) {
    //     message.warning('param serviceLabel is required');
    //     return;
    //   }

    //   const selected = this.state.options.find((opt: ServiceInfo) => getFullName(opt) === args.serviceLabel);
    //   if (selected) {
    //     this.handleAdd(selected);
    //   }
    // });
  }

  // componentWillUnmount(): void {
  //   this.actionListener();
  // }

  shouldComponentUpdate(nextProps: ServiceSlotTableProps, nextState: ServiceSlotTableState, nextContext: any) {

    if (!isEqual(nextProps.data, this.props.data)) {
      setTimeout(this.onInit, 100);

      return true;
    }

    return !isEqual(nextState, this.state);
  }

  onInit = async () => {
    const props = this.props;

    const res = await getSelectionOptions(SELECTION_KEY.AVAILABLE_INTERFACE_SERVICE);
    this.setState({
      options: res.map(item => serviceInfoToLocal(item.payload)),
      data: props.data,
    });

    this.initIntegrationOptions();
  }

  initIntegrationOptions = async () => {
    API.connection.getRawConnections()
      .then((res: any) => {
        const conns = (res || []).map(connectionToLocal);
        this.setState({ integrationOptions: conns });
      })
      .catch((err: Error) => {
        message.error(err.message);
      });
  }

  // updateIntegrationOptions = async () => {
  //   API.connection.getRawConnections()
  //     .then((res: any) => {
  //       const conns = (res || []).map(connectionToLocal);
  //       this.setState({ integrationOptions: conns });
  //     })
  //     .catch((err: Error) => {
  //       message.error(err.message);
  //     });
  // }

  render() {
    const {
      loading,
      data,
      modalData,
      options,
      integrationOptions
    } = this.state;
    const { frame, disabled } = this.props;


    const modalDisabled = modalData && (disabled || !!modalData.inheritedFromCompositeId);
    const curIntegration = modalData && integrationOptions && integrationOptions.find((opt: Connection) => opt.name === modalData.integrationLabel);
    return <NiSpin spinning={loading}>
      <BodyGroup
        foldable
        key="slot-body-group"
        noPadding
        className="slot-suggestion-card"
        title={localizedString('services')}
        titleExtra={<HelperPopover localizedKey="service_slot_hint" />}
        // className="value-check-body-group"
        extra={[
          (disabled ? '' :
            <NiSelect value={null}
              disabled={disabled}
              placeholder="Select integration for service"
              onChange={(value: string) => {
                const selected = integrationOptions.find((opt: Connection) => opt.name === value);
                if (selected) {
                  this.handleSelectIntegration(selected);
                }
              }}>
              {
                integrationOptions.map((conn) => (
                  <NiSelect.Option key={conn.name} value={conn.name}>{conn.name}</NiSelect.Option>
                ))
              }</NiSelect>
          )
        ]
        }
      >
        {modalData && <NiModal
          title={`Service slot(Integration: ${curIntegration?.name})`}
          width={'60%'}
          wrapClassName="dialog-act-modal"
          open={!!modalData}
          onCancel={this.handleModalCancel}
          onOk={modalDisabled ? undefined : this.handleModalConfirm}
          okButtonProps={modalDisabled ? {
            type: 'ghost',
            disabled: true
          } : undefined}
        >
          <NiForm
            titleline
            direction="vertical"
            items={[
              {
                key: 'service-label',
                label: localizedString('service_label'),
                content: <NiInput
                  style={{ width: '100%' }}
                  disabled={disabled || !!frame.originKey || !!modalData.inheritedFromCompositeId}
                  value={modalData.label}
                  onChange={(e: any) => {
                    this.setState({
                      modalData: {
                        ...modalData,
                        label: e.target.value
                      }
                    });
                  }}
                >
                </NiInput>
              },
              curIntegration && curIntegration.services && curIntegration.services.length > 1 && {
                key: 'service-type',
                label: 'Service type',
                content: <NiSelect
                  disabled={disabled}
                  allowClear
                  style={{ width: 200 }}
                  value={modalData?.type?.id}
                  onChange={(value: string) => {

                    const tp = curIntegration.services.find((service) => service.id === value);

                    this.setState({
                      modalData: {
                        ...modalData,
                        type: tp
                      }
                    });
                  }}
                >
                  {
                    curIntegration.services.map((service) => (
                      <NiSelect.Option key={service.id} value={service.id}>{service.name}</NiSelect.Option>
                    ))
                  }
                </NiSelect>
              } || undefined,
              //  {
              //   key: 'integration-label',
              //   label: 'Integration label',
              //   content: <NiSelect
              //     disabled={disabled}
              //     allowClear
              //     style={{ width: 200 }}
              //     value={modalData?.integrationLabel}
              //     onChange={(value) => {
              //       this.setState({
              //         modalData: {
              //           ...modalData,
              //           integrationLabel: value
              //         }
              //       });
              //     }}
              //   >
              //     {
              //       integrationOptions.map((conn) => (
              //         <NiSelect.Option key={conn.name} value={conn.name}>{conn.name}</NiSelect.Option>
              //       ))
              //     }
              //   </NiSelect>
              // }
            ]}
          />
        </NiModal>
        }
        <NiTable
          rowKey={(record: ServiceSlot) => `dialog-act-${record.id}`}
          dataSource={data}
          pagination={false}
          onRow={(record: ServiceSlot, index?: number) => ({
            onClick: () => {
              const modalData = cloneDeep(record);
              this.setState({
                modalData,
                index: index || 0,
                isNew: false
              });
            }
          })}
          columns={this.getColumns()}
        />
      </BodyGroup >
    </NiSpin >;
  }

  handleSelectIntegration = (selected: Connection) => {
    if (!selected) {
      return;
    }

    // if (this.props.data?.find(p => p.type.id === selected.id)) {
    //   message.warning('there is already a service slot with the same type');
    //   return;
    // }


    let defaultLabel = selected.name;

    let type: ReferenceNode | undefined;


    if ((!selected.services || selected.services.length === 0) && selected.implementationService) {
      type = {
        id: selected.implementationService.id as string,
        type: ParameterType.SERVICE,
        name: selected.implementationService.name
      };
    } else if (selected.services && selected.services.length === 1) {
      type = {
        id: selected.services[0].id as string,
        type: ParameterType.SERVICE,
        name: selected.services[0].name
      };
    } else if (selected.services && selected.services.length > 1) {
      type = {
        id: selected.services[0].id as string,
        type: ParameterType.SERVICE,
        name: selected.services[0].name
      };
    }

    this.setState(
      {
        modalData: {
          type,
          integrationLabel: selected.name,
          label: defaultLabel as string
        },
        isNew: true
      }
    );
  }

  // handleAdd = (selected: ServiceInfo) => {
  //   if (!selected) {
  //     return;
  //   }

  //   // if (this.props.data?.find(p => p.type.id === selected.id)) {
  //   //   message.warning('there is already a service slot with the same type');
  //   //   return;
  //   // }

  //   const label = (selected && getFullName(selected)) as string;

  //   const seperator = '.';
  //   const components = label.split(seperator);
  //   let defaultLabel = components[components.length - 1];

  //   if (defaultLabel.startsWith('I')) {
  //     defaultLabel = defaultLabel.substring(1);
  //   }

  //   defaultLabel = defaultLabel.substring(0, 1).toLowerCase() + defaultLabel.substring(1);

  //   if (selected && selected.id) {
  //     this.updateIntegrationOptions(selected.id);
  //   }

  //   this.setState(
  //     {
  //       modalData: {
  //         type: {
  //           id: selected.id as string,
  //           type: ParameterType.SERVICE,
  //           name: getFullName(selected) as string
  //         },
  //         label: defaultLabel as string
  //       },
  //       isNew: true
  //     }
  //   );
  // }

  getColumns = () => {
    const { disabled, frame } = this.props;
    return [
      {
        width: 300,
        title: localizedString('service_label'),
        dataIndex: 'label'
      },
      {
        // width: '50%',
        title: localizedString('type'),
        dataIndex: ['type', 'name']
      },
      {
        width: 150,
        title: 'Source',
        dataIndex: 'inheritedFromCompositeName',
        key: 'source',
        render: (sourceName: string, record: ServiceSlot) => {
          return sourceRender(record, frame.type);
        }
      },
      // admin
      {
        title: '',
        className: 'hide',
        key: 'operation',
        width: 70,
        render: (
          operation: any,
          record: ServiceSlot,
          index: number
        ) => {
          return (
            <div className="icon-area">
              {!disabled &&
                !record.originKey &&
                !record.inheritedFromCompositeId &&
                <DeleteOutlined
                  className="delete-btn"
                  onClick={(e: any) => {
                    e.stopPropagation();
                    this.handleDelete(record, index);
                  }}
                />
              }
            </div>
          );
        }
      }
    ];
  };

  handleDelete = async (record: ServiceSlot, index: number) => {
    const props = this.props;
    const nextData = cloneDeep(this.state.data);

    nextData.splice(index, 1);

    if (props.onChange) {
      props.onChange(nextData);
    }
  }

  handleModalCancel = () => {
    this.setState({ modalData: undefined, integrationOptions: [] });
  }

  handleModalConfirm = debounce(async () => {
    const { modalData, data, isNew, index } = this.state;
    const props = this.props;

    if (!modalData) {
      return;
    }

    if (!modalData.label || !modalData.label.length) {
      message.warning('Label is required!');
      return;
    }


    const nextItem = cloneDeep(modalData);
    const nextData = cloneDeep(props.data);

    if (isNew) {
      if (data.find(item => item.label === modalData.label)) {
        message.warning('Label is occupied');
        return;
      }

      nextData.push(nextItem);
    } else {
      nextData[index] = nextItem;
    }

    if (props.onChange) {
      props.onChange(nextData);
      this.setState({
        modalData: undefined,
        integrationOptions: []
      });
      return;
    }
  }, 500);
}
